var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('listarClientes',{attrs:{"titulo":'Consultar Ordenes de Trabajo',"busmodulo":{ busmodulo: _vm.busmodulo }}}),_c('consultarodt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }